import React from "react";
import "../styles/loader.css";
import { ThreeDots } from "react-loader-spinner";

const Loader = (props) => {
    return (
        <>
            {props.active === true &&
                <div className="overlay">
                <div className="overlay__inner">
                    <div className="overlay__content"><ThreeDots
                        height="80"
                        width="80"
                        color="#8FA87A"
                        radius="9"
                        ariaLabel="loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        style={{zIndex: '1000'}}
                        /></div>
                </div>
            </div>
            }
        </>
    )
}

export default Loader;